export enum Permissions {
  InvitePendingUser = 'INVITE_PENDING_USER',
  PendingUserActions = 'PENDING_USER_ACTIONS',
  ViewPendingUsers = 'VIEW_PENDING_USERS',
  QuoteActions = 'QUOTE_ACTIONS',
  ViewQuotes = 'VIEW_QUOTES',
  CreateServiceRequest = 'CREATE_SERVICE_REQUEST',
  ViewServiceRequests = 'VIEW_SERVICE_REQUEST',
  DeactivateAsset = 'DEACTIVATE_ASSET',
  AddNewAsset = 'ADD_NEW_ASSET',
  ViewAssetDetails = 'VIEW_ASSET_DETAILS',
  RelocateAsset = 'RELOCATE_ASSET',
  ViewAssets = 'VIEW_ASSETS',
  ViewPMList = 'VIEW_PM_LIST',
  ViewJobs = 'VIEW_JOBS',
  ViewJobDetails = 'VIEW_JOB_DETAILS',
  ViewDashboards = 'VIEW_DASHBOARDS',
  ViewQuoteDetails = 'VIEW_QUOTE_DETAILS'
}
